import { useQuery } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { DashboardTotalApartmentsResponseDto } from '@/features/dashboard/types/dashboard-dto';
import { useDashboardFilter } from '@/features/dashboard/hooks/useDashboardFilter';
import { UrlHelper } from '@/utils/UrlHelper';
import { DateTimeHelper } from '@/utils/dateTimeHelper';
import {useAxiosAuth} from "@/hooks/useAxiosAuth.ts";

export const useDashboardTotalApartmentsApi = () => {
  const axiosInstance = useAxiosAuth();
  const { filter } = useDashboardFilter();
  const { startDate, endDate, apartmentId } = filter;

  const apartmentIds = apartmentId?.map((apartment) => apartment.id);

  const {
    data: totalApartmentsData, 
    isLoading: isLoadingTotalApartmentsData, 
    isError: isErrorTotalApartmentsData
  } = useQuery({
    queryKey: [
        ApiConfig.queries.features.dashboard.queryKeys.totalApartments,
        startDate, endDate, apartmentId
    ],
    queryFn: async () => {
      const url = UrlHelper.buildUrlWithQueryParams(ApiConfig.queries.features.dashboard.endpoints.totalApartments, {
        startDate: DateTimeHelper.getDateOnly(startDate),
        endDate: DateTimeHelper.getDateOnly(endDate),
        apartmentId: apartmentIds
      });
      const { data } = await axiosInstance.get<DashboardTotalApartmentsResponseDto>(url);
      return data;
    },
  });

  return {
    totalApartmentsData, 
    isLoadingTotalApartmentsData, 
    isErrorTotalApartmentsData,
  }
};